module.exports = __webpack_public_path__ + "img/icon-piste-ciclabili.460d49fb.svg";